jQuery(document).ready(function($) {
    // musician panel
    $('[href="#musician-panel"]').on("click", function(e) {
        e.preventDefault();
        var $musicianId = $(this).data('musician-id');
        var $musicianSubPanel = $(".musician-panel[data-submusician-id="+$musicianId+"]");
        mainHandler.openPanel($musicianSubPanel);
    });

    $('body').on('click', '.list-page', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var selectedPage = this.getAttribute('data-list-active-page');
        var itemContainer = $('.list-large-container, .list-small-container');
        var nextId = 0;
        if (selectedPage != 0) {
            var showingItemCont = $('[data-list-page = '+selectedPage+']');
            itemContainer.addClass('hidden');
            showingItemCont.removeClass('hidden');
        } else {
            var hideFirstElement = false;
            var showFirstElement = false;
            var afterVisible = false; 
            $('body').find('.panel-pagination-list').find('.cell').children().each(function(){
                var id = this.getAttribute('data-list-active-page');
                var maxItem = this.getAttribute('data-max-item');
                var item = $('[data-list-active-page='+id+']');
                if ((hideFirstElement == false) && (!item.hasClass('hide'))) {
                    item.addClass('hide');
                    hideFirstElement = true;
                    nextId = parseInt(id)+parseInt(1);
                }
                if (afterVisible == false) { 
                    afterVisible = (!item.hasClass('hide'));
                } else {
                    if ((showFirstElement == false) && (item.hasClass('hide'))) {
                        item.removeClass('hide');
                        showFirstElement = true;
                        if (maxItem == id) {
                            $('[data-list-active-page=0]').addClass('hide');
                        }
                    }
                }                
            })
        }
        $('.list-page').removeClass('active');
        if (nextId > 0) {
            $('[data-list-active-page='+nextId+']').click();
        } else {
            $(this).addClass('active');
        }
    })

    $('body').on('click', '.grid-page', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var selectedPage = this.getAttribute('data-grid-active-page');
        var itemContainer = $('.grid-large-container, .grid-small-container');
        var nextId = 0;
        if (selectedPage != 0) {
            var showingItemCont = $('[data-grid-page = '+selectedPage+']');
            itemContainer.addClass('hide');
            showingItemCont.removeClass('hide');
        } else {
            var hideFirstElement = false;
            var showFirstElement = false;
            var afterVisible = false; 
            $('body').find('.panel-pagination-grid').find('.cell').children().each(function(){
                var id = this.getAttribute('data-grid-active-page');
                var maxItem = this.getAttribute('data-max-item');
                var item = $('[data-grid-active-page='+id+']');
                if ((hideFirstElement == false) && (!item.hasClass('hide'))) {
                    item.addClass('hide');
                    hideFirstElement = true;
                    nextId = parseInt(id)+parseInt(1);
                }
                if (afterVisible == false) { 
                    afterVisible = (!item.hasClass('hide'));
                } else {
                    if ((showFirstElement == false) && (item.hasClass('hide'))) {
                        item.removeClass('hide');
                        showFirstElement = true;
                        if (maxItem == id) {
                            $('[data-grid-active-page=0]').addClass('hide');
                        }
                    }
                }                
            })
        }
        $('.content-container').masonry();
        $('.grid-page').removeClass('active');
        if (nextId > 0) {
            $('[data-grid-active-page='+nextId+']').click();
        } else {
            $(this).addClass('active');
        }
    })

    $('[href="#video-list"]').on("click", function(e){
        e.preventDefault();
        var id = this.getAttribute('data-tag-id');
        if (id > 0) {
            var cook = [];
            cook.push(id);
            Cookies.set('tag', JSON.stringify(cook));
            window.location.href = "/video-list";
        }	
    })
});